import { Injectable } from '@angular/core';
import Swal, { SweetAlertResult } from 'sweetalert2';

export enum AlertType {
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
  Info = 'info',
  Question = 'question',
  Notification = 'notification'
}

@Injectable({
  providedIn: 'root'
})
export class SweetAlertService {

  private readonly alertConfig: Record<AlertType, {
    icon?: string;
    buttonColor?: string;
    titleClass?: string;
    defaultTitle?: string;
  }> = {
    success: {
      icon: 'assets/media/svg/alert/success-icon.svg',
      titleClass: 'swal2-title-success',
      defaultTitle: 'Successful'
    },
    warning: {
      icon: 'assets/media/svg/alert/warning-icon.svg',
      defaultTitle: 'Warning',
    },
    error: {
      icon: 'assets/media/svg/alert/error-icon.svg',
      titleClass: 'swal2-title-error',
      defaultTitle: 'Failed'
    },
    info: {
      icon: 'assets/media/svg/alert/info-icon.svg',
      titleClass: 'swal2-title-info',
      defaultTitle: 'Info'
    },
    question: {
      icon: 'assets/media/svg/alert/question-icon.svg',
      defaultTitle: 'Alert'
    },
    notification: {
      icon: 'assets/media/svg/alert/notifi-icon.svg',
      defaultTitle: 'Alert'
    }
  };

  showAlert(message: string, type: AlertType, title?: string, icon?: string) {
    const config = this.alertConfig[type];

    return Swal.fire({
      title: title || config.defaultTitle,
      html: message,
      imageUrl: icon || config.icon || '',
      imageWidth: 57,
      imageHeight: 57,
      imageAlt: "Icon",
      confirmButtonColor: 'var(--anq-navy-blue)',
      confirmButtonText: 'Close',
      customClass: {
        title: config.titleClass || 'var(--anq-navy-blue)'
      }
    });
  }

  async confirmPopup(
    message: string | HTMLElement = '', 
    title: string = '',
    icon: string = 'assets/media/svg/alert/warning-icon.svg',
    confirmButtonText: string = 'Yes', 
    confirmButtonColor: string = 'var(--anq-navy-blue)', 
    cancelButtonText: string = 'Cancel'
  ) {
    const result: SweetAlertResult = await Swal.fire({
      title: title,
      html: message,
      imageUrl: icon,
      imageWidth: 57,
      imageHeight: 57,
      imageAlt: "Icon",
      showCancelButton: true,
      showConfirmButton: true,
      reverseButtons: true,
      confirmButtonText: confirmButtonText,
      confirmButtonColor: confirmButtonColor,
      cancelButtonText: cancelButtonText
    });
    if (result.isConfirmed) return true;
    else if (result.isDenied) return false;
    return;
  }

  async confirmSignOut(title?: string) {
    const result: SweetAlertResult = await Swal.fire({
      title: title || 'You have been inactive, please click "Continue" to stay logged in',
      showCancelButton: true,
      showConfirmButton: true,
      reverseButtons: true,
      confirmButtonText: 'Continue',
      cancelButtonText: 'Sign out',
      confirmButtonColor: "var(--anq-navy-blue)",
      cancelButtonColor: "var(--red-500)"
    });
    if (result.isConfirmed) return true;
    else if (result.isDenied) return false;
    return;
  }

  closePopup() {
    Swal.close();
  }
}
